// extracted by mini-css-extract-plugin
export default {"twoCols":"responsiveStyles_twoCols__X5Mdn","twoColsInner":"responsiveStyles_twoColsInner__4TgX-","flip":"responsiveStyles_flip__3L+t9"};